import React from "react";
import { Typography } from "components";
import PropTypes from "prop-types";

import "./style.scss";

const StatusIndicator = ({
  percentage,
  color,
  large,
  childToRender,
  showEdge = true,
  trackWidth = 7,
}) => {
  const showEdges = () =>
    showEdge && !["100", "0"].includes(percentage.toString());

  const getColor = () => {
    switch (color) {
      case "green":
        return "#27AE60";

      case "yellow":
        return "#EFB008";

      case "purple":
        return "#7E6EF0";

      case "red":
        return "#DC2C2C";

      case "blue":
        return "#1966FC";

      default:
        return "";
    }
  };

  let style = {
    "--p": percentage,
    "--c": getColor(),
    "--b": `${trackWidth}px`,
  };

  return (
    <div className="status-indicator-container">
      <div
        className={`pie-track pie-track--${color} ${
          large ? "pie-track--large" : ""
        }`}
      ></div>
      <div
        className={`pie ${showEdges() ? "" : "no-round"} ${
          large ? "pie--large" : ""
        }`}
        style={style}
      >
        {childToRender || (
          <Typography variant="caption2">{percentage}%</Typography>
        )}
      </div>
    </div>
  );
};

StatusIndicator.propTypes = {
  percentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  large: PropTypes.bool,
  childToRender: PropTypes.node,
};

export default StatusIndicator;
